import { ResponseBody } from '../middleware';
import {
    AuthState,
    AuthTypes,
    MOBILE_SESSION_FORCE_LOGOUT,
    MOBILE_SESSION_OUT,
    UPDATE_FIRST_TIME_SETTINGS,
} from '../types/login';

const initState: Partial<AuthState> = {
    isAutheticatedByDeviceOrPin: false,
    manualLogout: false,
};
function authentication(state = initState, action: AuthTypes & ResponseBody<any>) {
    switch (action.type) {
        case UPDATE_FIRST_TIME_SETTINGS: {
            const { body = {} } = action;
            return { ...state, ...body };
        }
        case MOBILE_SESSION_OUT: {
            return { ...initState, manualLogout: true };
        }
        case MOBILE_SESSION_FORCE_LOGOUT: {
            return initState;
        }
        default:
            return state;
    }
}

export default authentication;
